import AbstractPolicy from '@/Services/Auth/Policies/AbstractPolicy';

export default class ReviewPolicy extends AbstractPolicy {
    static viewAny(user, model = null) {
        return false;
    }

    static view(user, model = null) {
        return false;
    }

    static create(user, model = null) {
        return false;
    }

    static update(user, model = null) {
        return false;
    }

    static delete(user, model = null) {
        return false;
    }

    static restore(user, model = null) {
        return false;
    }

    static forceDelete(user, model = null) {
        return false;
    }
}
